module.exports = __webpack_public_path__ + "assets/img/teacher (11).5411a1a2.png";